import { Switch } from 'react-router-dom'
import { Route } from '../core/components'
import { routesConfig } from '../core/configs/routes'
import { Login } from '../pages'

export const AuthRoutes = () => {
  return (
    <Switch>
      <Route
        exact
        path={routesConfig.authRoutes}
        redirect={routesConfig.auth.login}
      />
      <Route exact path={routesConfig.auth.login}>
        <Login />
      </Route>
    </Switch>
  )
}
